import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const rows = [
  { label: 'Akademi Trading', free: true, premium: true, enterprise: true },
  { label: 'AI Trading Analysis', free: false, premium: true, enterprise: true },
  { label: 'Radar Pasar', free: false, premium: true, enterprise: true },
  { label: 'Paper Trading', free: true, premium: true, enterprise: true },
  { label: 'Komunitas Eksklusif', free: true, premium: true, enterprise: true },
  { label: 'Trading Journal', free: true, premium: true, enterprise: true },
  { label: 'Watchlist & Alert', free: false, premium: true, enterprise: true },
  { label: 'Event & Webinar', free: false, premium: true, enterprise: true },
  { label: 'Prioritas Support', free: false, premium: false, enterprise: true },
];

function PricingComparison() {
  return (
    <section className="pricing-comparison">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="section-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0C8F86" strokeWidth="2.5"><rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>
              Bandingkan Paket
            </div>
            <h2 style={{ fontSize: 40, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 16, letterSpacing: '-1px' }}>
              Pilih Paket yang Tepat untuk Anda
            </h2>
            <p style={{ fontSize: 16, color: 'var(--text)', maxWidth: 520, margin: '0 auto', lineHeight: 1.7 }}>
              Mulai gratis dan upgrade sesuai kebutuhan belajar dan trading Anda.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          style={{ overflowX: 'auto' }}
        >
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Fitur</th>
                <th>Gratis</th>
                <th style={{ background: 'rgba(12,143,134,0.04)', borderTop: '2px solid #0C8F86' }}>Premium</th>
                <th>Enterprise</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.label} className={i % 2 === 0 ? '' : ''}>
                  <td>{row.label}</td>
                  <td>
                    <span className={`pricing-table__${row.free ? 'check' : 'minus'}`}>
                      {row.free ? <Check /> : <X />}
                    </span>
                  </td>
                  <td className="pricing-table__featured">
                    <span className={`pricing-table__${row.premium ? 'check' : 'minus'}`}>
                      {row.premium ? <Check /> : <X />}
                    </span>
                  </td>
                  <td>
                    <span className={`pricing-table__${row.enterprise ? 'check' : 'minus'}`}>
                      {row.enterprise ? <Check /> : <X />}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>

        <div style={{ textAlign: 'center', marginTop: 40 }}>
          <p style={{ fontSize: 14, color: 'var(--text)', marginBottom: 20 }}>
            Tidak yakin dengan pilihan Anda? Hubungi tim kami untuk konsultasi gratis.
          </p>
          <Link to="/pricing" className="final-cta__btn-primary" style={{ display: 'inline-flex' }}>
            Lihat Detail Paket <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default PricingComparison;
